import { API_CONFIG } from '../config/api'

// API Configuration
export const API_KEY = API_CONFIG.API_KEY

// Mock stats data for API fallback
export const mockStatsData = {
  "total_active_users": 150,
  "total_family_members": 45,
  "total_applications": 89,
  "total_revenue": 2500000
}

// Mock blacklist data for API fallback
export const mockBlacklistData = {
  "entries": [],
  "max_results": 50,
  "query": "",
  "results_count": 0,
  "search_type": "all"
}

// Mock user data for Discord search
export const mockUserData = {
  "entries": [],
  "max_results": 50,
  "query": "",
  "results_count": 0,
  "search_type": "all"
}

 